import { useMutation } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import useToast from "../useToast";

export const useUpdateEventStatus = () => {
  const { getAccessTokenSilently } = useAuth0();
  const apiUrl = process.env.REACT_APP_API_URL;
  const toast = useToast();

  return useMutation(
    async ({ eventId, status }) => {
      const token = await getAccessTokenSilently();

      const response = await axios.put(
        `${apiUrl}/api/events/update-status/${eventId}`,
        { status },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    },
    {
      onError: (error) => {
        const errorMessage =
          error.response?.data?.message || "Failed to update event status.";
        toast.error(errorMessage);
        console.error(
          "Error updating event status:",
          error.response ? error.response.data : error
        );
      },
    }
  );
};
